import React from 'react';
import { Hero } from './components/Hero';
import { ProductPeek } from './components/ProductPeek';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { SamplePlan } from './components/SamplePlan';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials, coachProfiles } from './data/testimonials';
// Review sections render only once data/testimonials.ts holds real buyer reviews.

export function App() {
  return <div className="min-h-screen w-full bg-cloud text-ink font-sans selection:bg-amber selection:text-ink" data-id="element-0" data-mp="3mkhlps1j704z">
      <MetaPixel data-id="element-1" data-mp="3rdki07xp0nov" />
      <main data-id="element-2" data-mp="3rd1bdndhtlq5">
        <Hero data-id="element-3" data-mp="3recdlirailf5" />
        <ProductPeek data-id="element-4" data-mp="5yjetptzbev" />
        <SocialProofBar data-id="element-5" data-mp="6hq1ea16ddl" />
        <PainGrid data-id="element-6" data-mp="4n5i12o8na1" />
        <ProductReveal data-id="element-7" data-mp="56lvdcob3ly" />
        <Tomes data-id="element-8" data-mp="2zl39tfhhuw2o" />
        <SamplePlan data-id="element-9" data-mp="2zld4hgdhhrep" />
        <Bonuses data-id="element-10" data-mp="2zm4yimrfnh2v" />
        <ValueStack data-id="element-11" data-mp="2zmo557bmuj1l" />
        <Urgency data-id="element-12" data-mp="2zn6biws0edn8" />
        <Pricing data-id="element-13" data-mp="33mow1rfx4mpj" />
        <Testimonials testimonials={shortTestimonials} profiles={coachProfiles} background="white" data-id="element-14" data-mp="33m5cy7ej7s9x" />
        <Guarantee data-id="element-15" data-mp="38l8h7pmotugu" />
        <Faq data-id="element-16" data-mp="38kqfwel64q22" />
        <Testimonials testimonials={moreTestimonials} title="Works alongside your club or school program" subtitle="Coaches use it to turn the practices they run into a planned, repeatable season." background="cream" data-id="element-17" data-mp="38k6v8q44vnkc" />
        <CostOfInaction data-id="element-18" data-mp="stuexv3nyxa2" />
        <Close data-id="element-19" data-mp="stccggqermtp" />
      </main>
      <Footer data-id="element-20" data-mp="swq8z8ce51t8" />
    </div>;
}